// extracted by mini-css-extract-plugin
export default {"container":"Attendance_container__HJkpw","attendanceHeader":"Attendance_attendanceHeader__7tm4-","buttons":"Attendance_buttons__igN5e"};